import axios from './axios.interceptors';

class ConfigurationServices {
    getConfigurationLogo = async (): Promise<any> => {
        try {
            const response = await axios.get('/api/configurations/logo');
            return response.data;
        } catch (err) {
            throw err;
        }
    }

    uploadConfigurationLogo = async (logoImage: any): Promise<any> => {
        return await axios.put(`/api/configurations/logo`, logoImage);
    }

    getIncreasePriceOnlineBooking = async (): Promise<any> => {
        try {
            const response = await axios.get(`/api/configurations/increase-price-online-booking`);
            return response.data;
        } catch (err) {
            throw err;
        }
    }
    
    updateIncreasePriceOnlineBooking = async (price: number): Promise<any> => {
        try {
            const response = await axios.post(`/api/configurations/increase-price-online-booking`, null, {
                params: { price }
            });
            return response.data;
        } catch (err) {
            throw err;
        }
    }    
}

export default new ConfigurationServices();